import _InputNumber from "antd/es/input-number";
var _excluded = ["addonAfter"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import cs from 'classnames';
import './index.less';
/**
 * import { OneInputNumber } from '@yy/one-ui'
 */
var OneInputNumber = function OneInputNumber(props) {
  var addonAfter = props.addonAfter,
    rest = _objectWithoutProperties(props, _excluded);
  if (addonAfter) {
    return /*#__PURE__*/React.createElement("div", {
      className: "one-input-number-group-wrapper"
    }, /*#__PURE__*/React.createElement(_InputNumber, _extends({}, rest, {
      className: cs('one-input-number', props.className)
    })), /*#__PURE__*/React.createElement("div", {
      className: "one-input-number-group-addon"
    }, addonAfter));
  }
  return /*#__PURE__*/React.createElement(_InputNumber, _extends({}, rest, {
    className: cs('one-input-number', props.className)
  }));
};
export default OneInputNumber;